import { BookMarked, GraduationCap, Languages, ShieldCheck } from "lucide-react";

const principles = [
  {
    icon: ShieldCheck,
    title: "Care before certainty",
    body: "I want to offer context without reducing a person to a label. The person always comes first.",
  },
  {
    icon: BookMarked,
    title: "Evidence, made readable",
    body: "When I publish a note, I try to translate psychiatric ideas clearly and mark where education ends and clinical advice begins.",
  },
  {
    icon: Languages,
    title: "Families belong in the conversation",
    body: "I write for people having a difficult time and for the people beside them who want to help without taking over.",
  },
];

export default function Profile() {
  return (
    <section className="profile-section" id="about" aria-labelledby="about-title">
      <div className="profile-section__heading">
        <p>A note from me</p>
        <h2 id="about-title">I’m learning psychiatry—and learning how to explain it with care.</h2>
      </div>

      <div className="profile-section__body">
        <article className="training-card">
          <div className="training-card__mark" aria-hidden="true">
            <GraduationCap size={30} />
          </div>
          <div>
            <p className="training-card__status">My current chapter</p>
            <h3>DNB Psychiatry · Year two</h3>
            <p>
              I’m currently completing the second year of my DNB in Psychiatry. I made this
              website as a living notebook: a place to share careful explanations, useful
              questions, and the things I’m learning along the way.
            </p>
          </div>
        </article>

        <figure className="profile-illustration">
          <img src="/images/illustrations/learning-desk.jpg" alt="A study desk with books, an open notebook, paper slips, pencil, and lamp" width="1536" height="1024" loading="lazy" />
          <figcaption>
            I want this to feel like a desk we can sit at: honest about where I am in training,
            careful with sources, and clear that a website cannot replace a clinical conversation.
          </figcaption>
        </figure>
      </div>

      <div className="principles-grid" aria-label="Principles behind this website">
        {principles.map(({ icon: Icon, title, body }, index) => (
          <article className={`principle principle--${index + 1}`} key={title}>
            <Icon size={22} aria-hidden="true" />
            <h3>{title}</h3>
            <p>{body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
